import type { MedicationProduct } from '../shared';

export const emgalityProducts: MedicationProduct[] = [
    {
        description: 'Emgality® Subcutaneous Solution Auto-injector 120 mg/mL',
        dosageForm: 'SOAJ',
        formLabel: '',
        packageSizeUnit: 'mL',
        strengthUnit: 'mg/mL',
        strengthValue: 120,
        imageUrl: '/static/img/emgality-120mg-pen.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002143611', packageQuantity: 1 },
            { ndc: '00002143601', packageQuantity: 1 },
            { ndc: '00002143661', packageQuantity: 1 },
        ],
        pricing: {},
        headlinePrices: [
            {
                type: 'DiscountedCashPrice',
                value: 299,
                qualifier: {
                    description: {
                        key: 'loading-dose',
                        text: '<body1>Your first prescription may be a loading dose, which includes 2 pens, totaling $598.</body1>',
                    },
                    text: ' per pen',
                },
            },
            { type: 'InsuredPriceAtPharmacy', value: -1 },
        ],
        pathway: {
            initialScreen: 'path-select',
            initialPathway: 'self-pay',
            favoredPathway: 'insurance',
        },
    },
    {
        description:
            'Emgality® Subcutaneous Solution Prefilled Syringe 100 mg/mL (300 mg Dose)',
        dosageForm: 'SOSY',
        formLabel: '',
        packageSizeUnit: 'mL',
        strengthUnit: 'mg/mL',
        strengthValue: 100,
        imageUrl: '/static/img/emgality-100mg-syringe.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002311509', packageQuantity: 3 },
            { ndc: '00002311501', packageQuantity: 1 },
        ],
        pricing: {},
        headlinePrices: [{ type: 'InsuredPriceAtPharmacy', value: -1 }],
        pathway: {
            initialScreen: 'attestation',
            initialPathway: 'insurance',
        },
    },
    {
        description:
            'Emgality® Subcutaneous Solution Prefilled Syringe 120 mg/mL',
        dosageForm: 'SOSY',
        formLabel: '',
        packageSizeUnit: 'mL',
        strengthUnit: 'mg/mL',
        strengthValue: 120,
        imageUrl: '/static/img/emgality-120mg-syringe.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002237711', packageQuantity: 1 },
            { ndc: '00002237701', packageQuantity: 1 },
        ],
        pricing: {},
        headlinePrices: [{ type: 'InsuredPriceAtPharmacy', value: -1 }],
        pathway: {
            initialScreen: 'attestation',
            initialPathway: 'insurance',
        },
    },
];
